import React from 'react'
import AnchorChevron from './AnchorChevron'
import { createSlug } from '../core/urls'

const FAQList = ({ faqs, halvedLayout }) => {
  return (
    <>
      {(faqs || []).map((faq, index) => (
        <div
          className={`flex justify-between w-full px-3 mb-3 md:mb-4 last:mb-0 ${
            halvedLayout ? 'md:w-1/2' : ''
          }`}
          key={faq.QuestionText}
        >
          <AnchorChevron
            href={`${faq.ParentPageURL}#${createSlug(faq.QuestionText)}`}
            copy={faq.QuestionText}
            key={`faq-${index}`}
          />
        </div>
      ))}
    </>
  )
}

export default FAQList
